import _ from 'lodash';

import Constants from '../Constants';
import ImageRegistry from '../ImageRegistry';
import RenderingState from '../RenderingState';
import TopicVizScaling from '../TopicVizScaling';
import { euclideanDistance } from '../Utils';
import Circle from '../VirtualDom/drawElements/Circle';
import LabeledImage from '../VirtualDom/drawElements/LabeledImage';
import VirtualDom from '../VirtualDom/VirtualDom';
import VirtualDomLayer from '../VirtualDom/VirtualDomLayer';

export default function createDocumentGroupLevel(
  clusterData,
  virtualDom: VirtualDom,
  scaling: TopicVizScaling,
  imageRegistry: ImageRegistry,
  renderingState: RenderingState,
  showLabel,
) {
  const neighborhoodRadius = 150 * scaling.getScaleFactor();
  const circles = [];
  const documentsByClusterId = _.groupBy(
    virtualDom.getLayer('documentPoints').getElements(),
    el => el.get('clusterId'),
  );
  for (const clusterId in documentsByClusterId) {
    let elements = documentsByClusterId[clusterId];
    const groups = [];

    while (elements.length > 0) {
      const group = [];
      const leftMostElement = _.sortBy(elements, el => el.get('x'))[0];
      for (const element of elements) {
        if (euclideanDistance(element, leftMostElement) <= neighborhoodRadius) {
          group.push(element);
        }
      }
      elements = _.difference(elements, group);
      groups.push(group);
    }

    for (const group of groups) {
      if (group.length < Constants.groupedDocuments.minDocumentsPerGroup) {
        continue;
      }
      const avgX = _.mean(group.map(el => el.get('x')));
      const avgY = _.mean(group.map(el => el.get('y')));
      circles.push(
        new Circle({
          x: avgX,
          y: avgY,
          radius: 4 * group.length * scaling.getScaleFactor(),
          fillColor: scaling.colorScale(clusterId),
          strokeColor: '#444',
          opacity: 0.5,
        }),
      );

      if (showLabel) {
        const widthLabel = Constants.groupedDocuments.characterWidth;
        circles.push(
          new LabeledImage({
            x: avgX,
            y: avgY,
            url: null,
            label: clusterData
              .getDocumentPointById(group[0].get('documentId'))
              .meta.words[0].toUpperCase(),
            borderColor: scaling.colorScale(clusterId),
            maxLines: 2,
            ellipsis: false,
            fontSize: Constants.groupedDocuments.fontSize,
            maxCharacterWidth: widthLabel,
            imageRegistry: imageRegistry,
          }),
        );
      }
    }
  }

  const layer = new VirtualDomLayer({
    name: 'documentGroups',
    elements: circles,
    keyFramesOpacity: [
      [Constants.thresholds.groupedDocuments[0] - 0.2, 0],
      [Constants.thresholds.groupedDocuments[0], 1],
      [Constants.thresholds.groupedDocuments[1], 1],
      [Constants.thresholds.groupedDocuments[1] + 0.2, 0],
    ],
  });
  virtualDom.registerLayer(layer);
}
